import { useSelector } from "react-redux";

import AntallIleggelserPerIleggelsetype from "./AntallIleggelserPerIleggelsetype";

function AntallIleggelserPerIleggelsetypePage(ownProps) {
  const antallIleggelserPerIleggelsetypeSubmittedForm = useSelector(
    (state) =>
      state.submittedForms.antallIleggelserPerIleggelsetypeSubmittedForm,
  );
  const antallIleggelserPerIleggelsetypeRapport = useSelector(
    (state) => state.rapporter.antallIleggelserPerIleggelsetypeRapport,
  );

  return (
    <AntallIleggelserPerIleggelsetype
      {...ownProps}
      antallIleggelserPerIleggelsetypeSubmittedForm={
        antallIleggelserPerIleggelsetypeSubmittedForm
      }
      antallIleggelserPerIleggelsetypeRapport={
        antallIleggelserPerIleggelsetypeRapport
      }
    />
  );
}

export default AntallIleggelserPerIleggelsetypePage;
